export function getContractParam({ building, flat, user }) {
  const param = {}

  if (building?.value) {
    param.building = building.value.toString()
  }

  if (flat?.value) {
    param.flat = flat.value.toString()
  }

  if (user.value) {
    param.user = user.value.toString()
  }

  return param
}
